import React from "react"
import {
  accesDirectTitle,
  accesDirectDescription,
  accesDirectContainer,
  editButtonTitle,
} from "./acces-direct.module.scss"
import ContentTransformer from "gatsby-theme-blank/src/components/Transformers/content-transformer"
import RenderAccesDirect from "./RenderAccesDirect/render-acces-direct"
import { useAccesDirect } from "gatsby-theme-blank/src/components/Home/AccesDirect/acces-direct-query"
import { Title, Description } from "./acces-direct-styled"
import EditButton from "gatsby-theme-blank/src/components/EditButton/edit-button"

//-----------------------Parent component---------------------------//

const AccesDirects = () => {
  const data = useAccesDirect()
  const accesdirectItem = data.allDirectLinkEntityDirectLinkEntity.edges
  if (accesdirectItem.length > 0) {
    return (
      <div>
        <Title className={accesDirectTitle}>
          <EditButton
            addedClass={editButtonTitle}
            link={
              "/taxonomy/term/" +
              data.taxonomyTermTypeDeLienDirect.drupal_internal__tid +
              "/edit"
            }
          />
          {data.taxonomyTermTypeDeLienDirect?.field_label || "Accès Direct"}
        </Title>
        {data.taxonomyTermTypeDeLienDirect.description && (
          <Description className={accesDirectDescription}>
            <ContentTransformer
              content={data.taxonomyTermTypeDeLienDirect.description.processed}
            ></ContentTransformer>
          </Description>
        )}
        <div className={accesDirectContainer} role={"list"}>
          <RenderAccesDirect accesDirectData={data} />
        </div>
      </div>
    )
  }
  return null
}

//-----------------------Parent component---------------------------//

//-----------------------Prop-Types---------------------------//

//-----------------------Prop-Types---------------------------//

export default AccesDirects
